import { DealActivityEventPriority, DealActivityStatus } from '@trnsact/trnsact-shared-types';
import { Theme } from '@mui/material/styles';
import { Block, CheckCircle, RadioButtonUnchecked, SvgIconComponent } from '@mui/icons-material';

export const COMPACT_MAX_MINUTES = 45;

export const PRIORITY_CONFIG: Record<DealActivityEventPriority, { label: string; color: (theme: Theme) => string }> = {
  [DealActivityEventPriority.High]: { label: 'High', color: theme => theme.palette.error.main },
  [DealActivityEventPriority.Medium]: { label: 'Medium', color: theme => theme.palette.warning.main },
  [DealActivityEventPriority.Low]: { label: 'Low', color: theme => theme.palette.success.main },
};

type StatusIconColor = 'primary' | 'disabled' | 'error';

export const STATUS_CONFIG: Record<
  DealActivityStatus,
  { label: string; icon: SvgIconComponent; color: StatusIconColor }
> = {
  [DealActivityStatus.None]: { label: 'None', icon: RadioButtonUnchecked, color: 'primary' },
  [DealActivityStatus.Open]: { label: 'Open', icon: RadioButtonUnchecked, color: 'primary' },
  [DealActivityStatus.Closed]: { label: 'Closed', icon: CheckCircle, color: 'disabled' },
  [DealActivityStatus.Cancelled]: { label: 'Cancelled', icon: Block, color: 'error' },
};
